<template>
  <section class="billing-section">
    <article class="billing-section__notice" :class="{ 'is-disabled': !billing.enabled }">
      <strong>Orden de pago del proceso de grado</strong>
      <p>{{ billing.helperText }}</p>
    </article>

    <article class="billing-section__panel">
      <div class="billing-section__head">
        <div>
          <h3>Orden de pago de derechos de grado</h3>
          <!-- <p>La información se consulta en Iceberg y se cruza con el programa inscrito del estudiante.</p> -->
        </div>
        <span class="billing-section__status" :class="statusClass(billing.paymentOrder.status)">
          {{ billing.paymentOrder.status }}
        </span>
      </div>

	      <dl class="billing-section__details">
        <div>
          <dt>Número de orden</dt>
          <dd>{{ billing.paymentOrder.orderNumber || 'Pendiente de emisión' }}</dd>
        </div>
        <div>
          <dt>Cliente</dt>
          <dd>{{ billing.paymentOrder.client || 'Sin información disponible' }}</dd>
        </div>
        <div>
          <dt>Identificación</dt>
          <dd>{{ billing.paymentOrder.identification || 'Sin información disponible' }}</dd>
        </div>
        <div>
          <dt>Documento</dt>
          <dd>{{ billing.paymentOrder.document || 'Sin información disponible' }}</dd>
        </div>
        <div>
          <dt>Periodo</dt>
          <dd>{{ billing.paymentOrder.period || 'Sin información disponible' }}</dd>
        </div>
        <div>
          <dt>Programa académico</dt>
          <dd>{{ billing.paymentOrder.program || 'Sin información disponible' }}</dd>
        </div>
        <div>
          <dt>Estado de pago</dt>
          <dd>{{ billing.paymentOrder.isPaid ? 'Pagada' : 'Pendiente de pago' }}</dd>
        </div>
        <div>
          <dt>Fecha</dt>
          <dd>{{ billing.paymentOrder.updatedAt || 'Sin fecha registrada' }}</dd>
        </div>
        <div>
          <dt>Medio de pago</dt>
          <dd>{{ billing.paymentOrder.paymentMethod || 'Sin información disponible' }}</dd>
        </div>
        <div>
          <dt>Valor orden</dt>
          <dd>{{ billing.paymentOrder.amountLabel }}</dd>
        </div>
        <div>
          <dt>Valor descuento</dt>
          <dd>{{ billing.paymentOrder.discountAmountLabel }}</dd>
        </div>
        <div>
          <dt>Valor total</dt>
          <dd>{{ billing.paymentOrder.amountLabel }}</dd>
        </div>
        <div>
          <dt>Valor pagado</dt>
          <dd>{{ billing.paymentOrder.paidAmountLabel || 'Pendiente' }}</dd>
        </div>
	      </dl>

	      <p class="billing-section__note">{{ billing.paymentOrder.note }}</p>

		      <div v-if="!billing.paymentOrder.isPaid" class="billing-section__support-note">
		        <p>
		          <strong>Nota:</strong> Si el pago de los derechos de grado fue realizado mediante cooperativa, cesantías o ICETEX, envía el soporte de pago al correo documentos.grados@ibero.edu.co, junto con tus datos personales para su validación.
		        </p>
		        <p>
		          Si realizaste el pago por otro medio y han transcurrido más de cinco (5) días hábiles sin que este se refleje en el sistema, por favor comunícate con nosotros para brindarte apoyo al correo servicioalestudiante@ibero.edu.co
		        </p>
		      </div>

	      <a
	        v-if="!billing.paymentOrder.isPaid && billing.paymentOrder.portalUrl"
        :href="billing.paymentOrder.portalUrl"
        target="_blank"
        rel="noopener noreferrer"
        class="billing-section__portal-link"
      >
        Ir al portal financiero
      </a>
    </article>
  </section>
</template>

<script>
export default {
  name: 'GraduationBillingSection',
  props: {
    billing: {
      type: Object,
      required: true,
    },
  },
  methods: {
    statusClass (status) {
      if (status === 'Pagada' || status === 'OK') {
        return 'is-success'
      }

      if (status === 'Pendiente de pago') {
        return 'is-warning'
      }

      return 'is-warning'
    },
  },
}
</script>

<style scoped>
.billing-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.billing-section__notice,
.billing-section__panel {
  background: #fff;
  border: 1px solid var(--ibero-border);
  border-radius: 12px;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.05);
}

.billing-section__notice {
  padding: 18px 22px;
  border-left: 4px solid var(--ibero-primary);
}

.billing-section__notice.is-disabled {
  border-left-color: var(--ibero-accent);
}

.billing-section__notice strong {
  display: block;
  color: var(--ibero-primary);
  font-size: 16px;
}

.billing-section__notice p {
  margin: 8px 0 0;
  color: var(--ibero-muted);
  font-size: 14px;
}

.billing-section__panel {
  padding: 22px;
}

.billing-section__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
}

.billing-section__head h3 {
  margin: 0;
  color: var(--ibero-primary);
  font-size: 19px;
  font-weight: 700;
}

.billing-section__head p {
  margin: 8px 0 0;
  color: var(--ibero-muted);
  font-size: 14px;
}

.billing-section__status {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 120px;
  padding: 10px 14px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 700;
}

.billing-section__status.is-success {
  background: rgba(34, 139, 34, 0.12);
  color: #206a20;
}

.billing-section__status.is-warning {
  background: rgba(242, 169, 0, 0.16);
  color: #8a6200;
}

.billing-section__details {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  margin: 22px 0 0;
}

.billing-section__details dt {
  color: var(--ibero-text);
  font-size: 12px;
  font-weight: 800;
  text-transform: uppercase;
}

.billing-section__details dd {
  margin: 8px 0 0;
  color: var(--ibero-muted);
  font-size: 15px;
  font-weight: 400;
  line-height: 1.5;
}

.billing-section__note {
  margin: 18px 0 0;
  color: #4b5563;
  font-size: 14px;
  line-height: 1.6;
}

.billing-section__support-note {
  margin-top: 16px;
  padding: 14px 16px;
  border-radius: 14px;
  background: #f8fafc;
  border: 1px solid rgba(148, 163, 184, 0.25);
  color: #334155;
  font-size: 14px;
  line-height: 1.7;
}

.billing-section__support-note p {
  margin: 0;
}

.billing-section__support-note p + p {
  margin-top: 10px;
}

.billing-section__portal-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-top: 18px;
  padding: 12px 18px;
  border-radius: 999px;
  background: var(--ibero-primary);
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  text-decoration: none;
}

.billing-section__portal-link:hover {
  opacity: 0.92;
}

@media (max-width: 620px) {
  .billing-section__details {
    grid-template-columns: 1fr;
  }
}
</style>
